<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">备件盘点</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建盘点单</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        clearable
        v-model="searchData.Code"
        placeholder="请输入盘点单号"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        style="width: 300px; margin-left: 10px"
        v-model="searchData.CheckTime"
        value-format="yyyy-MM-dd"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>

      <SelectData
        v-model="searchData.Status"
        :locationOptions="[
          { label: '未盘点', Id: '0' },
          { label: '已盘点', Id: '1' },
        ]"
        placeholder="请选择单据状态"
        style="width: 230px; margin-left: 10px"
      ></SelectData>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <el-table-column label="盘点单号" align="center" prop="Code" sortable>
        </el-table-column>

        <el-table-column
          label="盘点时间"
          align="center"
          prop="CheckTime"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.CheckTime
                ? moment(scope.row.CheckTime).format('YYYY-MM-DD ')
                : ''
            }}
          </template>
        </el-table-column>

        <el-table-column label="备注" align="center" prop="Remarks" sortable>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="Status" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status === 0">未盘点</el-tag>
            <el-tag type="success" v-if="scope.row.Status === 1">
              已盘点</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-dropdown>
              <span class="el-dropdown-link">
                <span style="font-size: 12px">操作</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="width: 80px">
                  <el-button
                    type="text"
                    @click="handleEdit(scope.row, 1)"
                    v-if="scope.row.Status == 1"
                    style="
                      color: #409eff;
                      width: 100%;
                      display: block;
                      margin-left: 0;
                    "
                    >详情</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleEdit(scope.row, 2)"
                    v-if="scope.row.Status == 0"
                    style="
                      color: #409eff;
                      width: 100%;
                      display: block;
                      margin-left: 0;
                    "
                    >确认盘点</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleExport(scope.row)"
                    style="
                      color: #409eff;
                      width: 100%;
                      display: block;
                      margin-left: 0;
                    "
                    >导出</el-button
                  >
                  <Upload
                    v-if="scope.row.Status == 0"
                    :text="'导入'"
                    style="width: 100%; margin-left: 0; text-align: center"
                    ref="Upload"
                    :butType="{
                      type: 'text',
                      icon: 'none',
                    }"
                    :uploadUrl="
                      $rootUrl +
                      '/TD/TD_CheckDetail/ImporttD_CheckDetailDTOToDataBase'
                    "
                    @success="handleSearch"
                  ></Upload>
                  <el-button
                    type="text"
                    @click.stop="handleEdit(scope.row)"
                    v-if="scope.row.Status == 0"
                    style="
                      color: #409eff;
                      width: 100%;
                      display: block;
                      margin-left: 0;
                    "
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click.stop="handleDetele([scope.row])"
                    v-if="scope.row.Status == 0"
                    style="
                      color: #f56c6c;
                      width: 100%;
                      display: block;
                      margin-left: 0;
                    "
                    >删除</el-button
                  >
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
import Upload from '@/components/Upload/Upload.vue'
import SelectData from '@/components/SelectData/SelectData.vue'
export default {
  data() {
    return {
      moment,
      tools,
      searchData: {
        Code: '',
        CheckTime: [],
        Status: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, Upload, SelectData },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'CheckTime', [firstDay, lastDay])
      }
    },
    handleExport(row) {
      tools.download(
        this.$rootUrl + `/TD/TD_CheckDetail/ExportToExcel?checkId=${row.Id}`,
        '盘点单' + row.Code,
        '.xlsx',
        'get'
      )
    },
    selectable(row, index) {
      return row.Status == 0
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/TD/TD_CheckMain/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'MaterialType',
              Keyword: this.FittingsTreeSearch || '',
            },
            {
              Condition: 'Code',
              Keyword: this.searchData.Code,
            },
            {
              Condition: 'CheckTime',
              Keyword:
                this.searchData.CheckTime?.length > 0
                  ? this.searchData.CheckTime.join(',')
                  : '',
            },
            {
              Condition: 'Status',
              Keyword: this.searchData.Status,
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建盘点')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该盘点单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/TD/TD_CheckMain/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row, num) {
      if (num == 1) {
        this.$refs.EditForm.openForm('盘点详情', row, true, true)
        return
      }
      if (num == 2) {
        this.$refs.EditForm.openForm('确认盘点', row, true, false)
        return
      }
      this.$refs.EditForm.openForm('编辑盘点', row, false, false)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['FittingsTreeSearch']),
  },
  watch: {
    FittingsTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
</style>
